import { FC, useState } from 'react'
import { useIntl } from 'react-intl'
import { PageTitle } from '../../../_metronic/layout/core'
import { ScheduleListModal } from './_modals/ScheduleListModal'
import { ScheduleViewModal } from './_modals/ScheduleViewModal'
import { useSelector, shallowEqual } from 'react-redux'
import { RootState } from '../../../setup'
import { UserModel } from '../../modules/auth/models/UserModel'
import { DeleteModal } from '../../components/modals/DeleteModal'
import ScheduleApi from '../../../infrastructure/api/ScheduleApi'
import { ScheduleFormModal } from './_modals/ScheduleFormModal'

const SchedulePage: FC = () => {
    const [itemId, setItemId] = useState('')
    const [itemName, setItemName] = useState('')
    const [showDelete, setShowDelete] = useState(false)
    const handleCloseDelete = () => setShowDelete(false)
    const handleShowDelete = () => setShowDelete(true)


    const [refresh, setRefresh] = useState<number>(0)
    const [showForm, setShowForm] = useState(false)
    const handleCloseForm = () => { setShowForm(false); setRefresh(refresh + 1) }
    const handleShowForm = () => setShowForm(true)

    const [showView, setShowView] = useState(false)
    const handleCloseView = () => setShowView(false)
    const handleShowView = () => setShowView(true)

    const user: UserModel = useSelector<RootState>(({ auth }) => auth.user, shallowEqual) as UserModel

    async function deleteSchedule(itemId: string) {
        var response = await ScheduleApi.DeleteSchedule(itemId)
        setRefresh(refresh + 1)
    }


    const onClickItem = (value: string, name: string, type: string) => {
        setItemId(value)
        setItemName(name)
        switch (type) {
            case 'view':
                handleShowView()
                break
            case 'delete':
                handleShowDelete()
                break
            default:
                handleShowForm()
                break
        }
    }

    return (
        <>
            <div className='card mb-5 mb-xl-8'>
                <div className='card-header border-0 pt-5'>
                    <h3 className='card-title align-items-start flex-column'></h3>
                </div>

                <div className='card-body py-3'>
                    <ScheduleViewModal itemId={itemId} show={showView} handleClose={handleCloseView} />
                    <ScheduleListModal refresh={refresh} onClickItem={onClickItem} />
                    <ScheduleFormModal itemId={itemId} show={showForm} handleClose={handleCloseForm} />
                    <DeleteModal
                        itemId={itemId}
                        itemName={itemName}
                        handleClose={handleCloseDelete}
                        show={showDelete}
                        type='Schedule'
                        confirm={deleteSchedule}
                    />
                </div>
            </div>
        </>
    )
}

const ScheduleWrapper: FC = () => {
    const intl = useIntl()
    return (
        <>
            <PageTitle breadcrumbs={[]}>Schedule</PageTitle>
            <SchedulePage />
        </>
    )
}

export { ScheduleWrapper }
